import React, { Fragment, useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
export default ({
  name,
  label,
  type,
  value,
  initailValue,
  onChange,
  options,
  disabled,
  required,
  description,
  min,
  step,
  placeholder,
  fileNames,
  defaultfiles,
  onViewFile,
}) => {
  const [inputValue, setInputValue] = useState("");

  // Handle controlled vs uncontrolled component
  const isControlled = value !== undefined;
  const currentValue = isControlled ? value : inputValue;

  const handleChange = (e) => {
    if (!isControlled) {
      setInputValue(e.target.value);
    }
    if (onChange) {
      onChange(e);
    }
  };

  useEffect(() => {
    if (!isControlled && initailValue) {
      setInputValue(initailValue);
    }
  }, [initailValue, isControlled]);
  return (
    <div className="form-group row m-1">
      <label label className="col-lg-4 col-form-label">
        {label}
        {required && <span className="text-danger">*</span>}
      </label>

      <div className="col-lg-6">
        {type === "select" ? (
          <div>
            <select
              key={name}
              className="form-control"
              value={currentValue || ""}
              onChange={handleChange}
              disabled={disabled}
            >
              {!currentValue && <option value="">please-select</option>}

              {options.map((opt) => (
                <option key={opt} value={opt}>{opt}</option>
              ))}
            </select>
            <span className="text-danger">
              <small>{description}</small>
            </span>
          </div>
        ) : type === "text" || type === "number" ? (
          <div>
            <input
              key={name}
              className="form-control"
              type={type}
              name={name}
              value={currentValue}
              onChange={handleChange}
              disabled={disabled}
              required={required}
              min={min}
              step={step}
              placeholder={placeholder}
            />
            <small>{description}</small>
          </div>
        ) : type === "date" || type === "time" ? (
          <>
            <input
              key={name}
              className="form-control"
              placeholder="dd-mm-yyyy"
              type={type}
              name={name}
              value={currentValue}
              onChange={handleChange}
              disabled={disabled}
              required={required}
            />
          </>
        ) : type === "textarea" ? (
          <textarea
            key={name}
            className="form-control"
            type={type}
            name={name}
            value={currentValue}
            rows={"3"}
            onChange={handleChange}
            disabled={disabled}
            required={required}
          />
        ) : type === "file" ? (
          <div className="basic-form custom_file_input">
            <div className="input-group">
              <div className="custom-file">
                <input
                  key={name}
                  type="file"
                  multiple
                  className="custom-file-input"
                  onChange={handleChange}
                  disabled={disabled}
                />
                {fileNames.length > 0 ? (
                  <label className="custom-file-label">{fileNames}</label>
                ) : (
                  <label className="custom-file-label">choose file</label>
                )}
              </div>
            </div>
            {defaultfiles && (
              <span className="text-info">
                <Link
                  key={defaultfiles}
                  className="text-muted"
                  to="#"
                  onClick={() => onViewFile(defaultfiles)}
                >
                  <small>{defaultfiles}</small>
                </Link>
              </span>
            )}
          </div>
        ) : type === "radio" ? (
          <div className="basic-form">
            {options.map((opt) => (
              <div key={opt} className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name={name}
                  value={opt}
                  onChange={handleChange}
                  checked={currentValue === opt}
                />
                <label className="form-check-label">{opt}</label>
              </div>
            ))}
            <span className="text-danger">
              <small>{description}</small>
            </span>
          </div>
        ) : (
          {}
        )}
      </div>
    </div>
  );
};
